module.exports = __webpack_public_path__ + "images/rich_heading/sports/bg_2fe9c45f91586aea38a97684add92a58.png";